import { GenericRequest } from './schedulingModels/GenericRequest';

export type ScheduleRequestRef = {
  scheduleCode: string;
  requestCode: string;
};

const fromGenericRequest = ({ scheduleCode, requestCode }: GenericRequest): ScheduleRequestRef => ({
  scheduleCode,
  requestCode,
});

const fromRequestRef = ({ scheduleCode, requestCode }: ScheduleRequestRef): ScheduleRequestRef => ({
  scheduleCode,
  requestCode,
});

const fromGenericRequests = (requests: GenericRequest[]): ScheduleRequestRef[] =>
  requests.map(request => fromGenericRequest(request));

const matchesRequestRef = <R extends Partial<ScheduleRequestRef>>(ref1: ScheduleRequestRef, ref2: R): boolean =>
  ref1.scheduleCode === ref2.scheduleCode && ref1.requestCode === ref2.requestCode;

const isSameRequestRef = (ref1: ScheduleRequestRef, ref2: ScheduleRequestRef): boolean => matchesRequestRef(ref1, ref2);

export const ScheduleRequestRef = {
  isSameRequestRef,
  matchesRequestRef,
  fromGenericRequest,
  fromGenericRequests,
  fromRequestRef,
};
